// eslint-disable-next-line import/no-anonymous-default-export
export const color = {
  WHITE: "#FFFFFF",
  FHGREEN: "#338F86",
  // Darker brand teal for TEXT on white backgrounds. FHGREEN (#338F86) has a
  // 3.88:1 contrast ratio on white — below the WCAG AA 4.5:1 minimum for
  // normal-size text (axe: color-contrast, serious). This shade measures
  // 5.23:1. Keep FHGREEN for fills/borders/large text; use this for links
  // and body-size text on light backgrounds.
  FHGREEN_TEXT: "#2A7870",
  TEXTGREY: "#4F566B",
  FHADMIN: "#3786D6",
  ADMINHEADING: "#595959",
  DISABLED: "#cccccc",
  REJECT: "#FF0000",
  LOANTEXT: "#31332C",
  GREYBG: "#D9DCE1",
  BGGREY: "#D9DCE1",
  primaryButtonBackground: "#333",
  primaryButtonText: "#fff",
  agreementFont: "#338F86",
  greyColor: "#cccccc",
  whiteColor: "#FFFFFF",
  darkGreyColor: "#979797",
};

export const SIDEBAR_DARK = "#15292B";
